import { ConnectedDashboardMetrics } from '../ConnectedDashboardMetrics';

export function ChargePointListDashboards() {
  return (
    <ConnectedDashboardMetrics
      dashboards={['onlinecp', 'onlineport', 'evcharge']}
    />
  );
}
